// extracted by mini-css-extract-plugin
export default {"usageWarningDialogParagraph":"PromoUsageWarningDialog_usageWarningDialogParagraph__ewgIa"};